import { render, staticRenderFns } from "./ApprovalPendingCourseCard.vue?vue&type=template&id=4fc5193f&scoped=true&"
import script from "./ApprovalPendingCourseCard.vue?vue&type=script&lang=js&"
export * from "./ApprovalPendingCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalPendingCourseCard.vue?vue&type=style&index=0&id=4fc5193f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc5193f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VCard,VCardText,VCardTitle,VIcon,VImg})
